/* eslint-disable @typescript-eslint/camelcase */
import { AxiosResponse } from 'axios';
import api from './api';

// const Register = async (payload: User): Promise<User> => (
//   api.post('register', payload)
//     .then((res) => res.data)
//     .catch(() => console.error('[Service - Hub] Não foi possível cadastrar'))
// );

const getCustomerPlan = async (
  planId: number | string,
): Promise<AxiosResponse<Services.User.Response.GetCustomerPlan>> => (
  api.get(`customerplans/${planId}`)
);

const getCustomerPlanId = async (
  planId: string | number,
): Promise<AxiosResponse<Services.User.Response.GetCustomerPlanId>> => {
  const url = `customerplansid/${planId}`;
  return api.get(url);
};

const getCustomerPlansLive = (
  idCustomer: any,
): Promise<AxiosResponse<Services.User.Response.GetCustomerPlansLive>> => {
  const url = `customerplanslivelist/${idCustomer}`;
  return api.get(url);
};

const getAllCustomerPlans = (
  idCustomer: any,
): Promise<AxiosResponse<Services.User.Response.GetAllCustomerPlans>> => (
  api.get(`customerplanslist/${idCustomer}`)
);

const getCustomerPlansPlayerWebTV = (
  idCustomerPlans: any,
): Promise<AxiosResponse<Services.User.Response.GetCustomerPlansPlayerWebTV>> => {
  const url = `customerplansplayerwebtvlist/${idCustomerPlans}`;
  return api.get(url);
};

const getHotsiteMediaSocial = (
  id: any,
): Promise<AxiosResponse<Services.User.Response.GetHotsiteMediaSocial>> => {
  const url = `hotsitemediasocial/${id}`;
  return api.get(url);
};

const getAllHotsiteMediaSocial = (
): Promise<AxiosResponse<Services.User.Response.GetAllHotsiteMediaSocial>> => (
  api.get('hotsitemediasocial')
);

const createHotsiteMediaSocial = (
  hotsiteMediaSocialData: any,
): Promise<AxiosResponse<Services.User.Response.CreateHotsiteMediaSocial>> => (
  api.post('hotsitemediasocial', hotsiteMediaSocialData)
);

const updateHotsiteMediaSocial = (
  id_customer_plans: string | number,
  hotsiteMediaSocialData: any,
): Promise<AxiosResponse<Services.User.Response.UpdateHotsiteMediaSocial>> => (
  api.put(`hotsitemediasocial/${id_customer_plans}`, hotsiteMediaSocialData)
);

const createSelectedPlansId = (
  categoryId: string | number,
  customerPlansCategoryData: any,
): Promise<AxiosResponse<Services.User.Response.CreateSelectedPlansId>> => {
  const url = `customerplansid/${categoryId}/updateSelectedPlanId`;
  return api.post(url, customerPlansCategoryData);
};

const getVideos = async (payload: Services.User.GetVideos) => (
  api.get<Services.User.Response.GetVideos>(
    `/hotsites/videos/${encodeURIComponent(payload.encryptedGalleryId)}`,
    { params: { ...payload, encryptedGalleryId: undefined } },
  )
);

const ValidateToken = async (payload: string): Promise<AxiosResponse> => (
  api.post('/auth/hashExternalHubLogin',
    {
      hash: payload,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: 'WgLIhz14npp3Vu5BNu04byX6sR2Y55',
      },
    })
);

export default {
  getCustomerPlan,
  ValidateToken,
  getCustomerPlanId,
  getCustomerPlansLive,
  getAllCustomerPlans,
  getCustomerPlansPlayerWebTV,
  getHotsiteMediaSocial,
  getAllHotsiteMediaSocial,
  createHotsiteMediaSocial,
  updateHotsiteMediaSocial,
  createSelectedPlansId,
  getVideos,
};
